<template>
  <div class="mt-4">
    <b-row v-if="loadingData && !loadError">
      <b-col v-for="item in 3" cols="12" md="6" lg="4" :key="item" class="mb-4">
        <b-progress
          variant="primary"
          :max="100"
          class="w-100"
          show-progress
          animated
          height="200px"
        >
          <b-progress-bar :value="100">Loading...</b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>

    <b-row v-else-if="loadError" class="mt-4" align-v="">
      <b-col cols="12" class="mb-4">
        <div class="text-center" title="Could not load, click on retry">
          <b-button
            class="w-100"
            style="height:200px"
            size="sm"
            @click="orderedItems()"
            variant="light"
          >
            <bad-network-icon />
            <br />Error Loading Data, <br />click to retry
            <reload-icon class="ml-1" />
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- Desktop view -->
    <div class="" v-if="orderedProduct.length > 0">
      <section
        class="p-4 order-container pill mb-3 desktop-view"
        v-for="(item, index) in orderedProduct"
        :key="index + 'e'"
      >
        <div class="d-flex justify-content-between text-light">
          <!-- <div class=" text-light"> -->
          <p>OrderID: {{ item.reference }}</p>
          <p>{{ item.date }}</p>
          <p class=" px-2 py-1 rounded" :class="item.status">
            {{ item.status }}
          </p>
          <!-- </div> -->
        </div>
        <b-row class="no-gutters px-3 py-2 order-header">
          <b-col lg="6" md="6" sm="6" cols="12" class="d-flex">
            <h6 class="mb-0">ITEMS</h6>
          </b-col>
          <b-col
            lg="2"
            md="2"
            sm="1"
            cols="4"
            class="d-flex justify-content-center align-items-center"
          >
            <h6 class="mb-0">QTY</h6>
          </b-col>
          <b-col
            g="2"
            md="2"
            sm="3"
            cols="4"
            class=" d-flex justify-content-center align-items-center"
          >
            <h6 class="mb-0">UNIT COST</h6>
          </b-col>
          <b-col
            lg="2"
            md="2"
            sm="3"
            cols="4"
            class="d-flex justify-content-center align-items-center"
          >
            <h6 class="mb-0">SUBTOTAL</h6>
          </b-col>
        </b-row>

        <b-row
          class="no-gutters bg-light p-3 mb-3 shadow-lg "
          v-for="(prods, index) in item.cart.content"
          :key="index + 'a'"
        >
          <b-col lg="1" md="1">
            <b-avatar
              rounded="sm"
              :src="prods.edible.image"
              size="5rem"
            ></b-avatar>
          </b-col>
          <b-col
            lg="5"
            md="5"
            sm="6"
            cols="12"
            class="d-flex justify-content-between"
          >
            <div class="ml-2">
              <h6 class="mb-0">{{ prods.edible.name }}</h6>
              <small>{{ prods.edible.description }} </small>
            </div>
          </b-col>
          <b-col
            lg="2"
            md="2"
            sm="1"
            cols="4"
            class="d-flex justify-content-center align-items-center"
          >
            <div class="">
              <p>{{ prods.quantity }}</p>
            </div>
          </b-col>
          <b-col
            lg="2"
            md="2"
            sm="3"
            cols="4"
            class=" d-flex justify-content-center align-items-center"
          >
            <div class="">
              <p>{{ formatMoney(prods.edible.price) }}</p>
            </div>
          </b-col>
          <b-col
            lg="2"
            md="2"
            sm="3"
            cols="4"
            class="d-flex justify-content-center align-items-center"
          >
            <div class="">
              <p>{{ formatMoney(prods.cost) }}</p>
            </div>
          </b-col>
          <!-- <b-col lg='2' md="3" sm="1"  class="d-flex justify-content-center align-items-center text-primary">
                      Delivered
                  </b-col> -->
        </b-row>
        <div class="d-flex">
          <small class="text-light">
            Delivery cost: {{ formatMoney(item.deliverycost) }}
          </small>
          <h5 class="ml-auto mb-0">
            Total: {{ formatMoney(item.cart.amount) }}
          </h5>
        </div>
      </section>
    </div>

    <!-- mobile view -->
    <div class="" v-if="orderedProduct.length > 0">
      <section
        class="p-4 order-container pill mb-3 mobile-view"
        v-for="(item, index) in orderedProduct"
        :key="index + 'e'"
      >
        <div class="d-flex justify-content-between text-light">
          <!-- <div class=" text-light"> -->
          <p>OrderID: {{ item.reference }}</p>
          <p>{{ item.date }}</p>
          <p class=" px-2 py-1 rounded" :class="item.status">
            {{ item.status }}
          </p>
          <!-- </div> -->
        </div>

        <b-row
          class="no-gutters bg-light p-3 mb-3 shadow-lg "
          v-for="(prods, index) in item.cart.content"
          :key="index + 'a'"
        >
          <b-col lg="1" md="1">
            <b-avatar
              rounded="sm"
              :src="prods.edible.image"
              size="5rem"
            ></b-avatar>
          </b-col>
          <b-col
            lg="5"
            md="5"
            sm="6"
            cols="12"
            class="d-flex justify-content-between"
          >
            <div class="ml-2">
              <h6 class="mb-0">{{ prods.edible.name }}</h6>
              <small>{{ prods.edible.description }} </small>
            </div>
          </b-col>
          <b-col
            lg="2"
            md="2"
            sm="1"
            cols="4"
            class="d-flex justify-content-center align-items-center"
          >
            <div class="">
              <p>{{ prods.quantity }}</p>
            </div>
          </b-col>
          <b-col
            lg="2"
            md="2"
            sm="3"
            cols="4"
            class=" d-flex justify-content-center align-items-center"
          >
            <div class="">
              <p>{{ formatMoney(prods.edible.price) }}</p>
            </div>
          </b-col>
          <b-col
            lg="2"
            md="2"
            sm="3"
            cols="4"
            class="d-flex justify-content-center align-items-center"
          >
            <div class="">
              <p>{{ formatMoney(prods.cost) }}</p>
            </div>
          </b-col>
          <!-- <b-col lg='2' md="3" sm="1"  class="d-flex justify-content-center align-items-center text-primary">
                      Delivered
                  </b-col> -->
        </b-row>
        <div class="d-flex">
          <h5 class="ml-auto mb-0">
            Total: {{ formatMoney(item.cart.amount) }}
          </h5>
        </div>
      </section>
    </div>

    <b-row
      v-if="
        orderedProduct.length == 0 && loadingData == false && loadError == false
      "
    >
      <b-col cols="12">
        <div
          class="d-flex bg-white dash-card p-5 align-items-center justify-content-center"
          style="height:200px"
        >
          <div class="wrap text-center">
            <h5>You have no ordered items</h5>
            <b-button variant="primary" @click="$emit('setInvestTab')"
              >SHOP NOW</b-button
            >
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- <b-row class="no-gutters d-none">
            <b-col
                cols="12"
                class="bg-light"
            >

            <div class="d-flex p-4">
                <img
                    rounded="sm" 
                    :src="image" 
                    size="140px"
                    style="height: 100px; width: 130px; object: fit"
                >
                <div class=" px-3 w-100 position-relative d-flex justify-content-between" >
                    <div class="">
                        <h5>Fresh Tomatoes</h5>
                        <small class="d-block">psum dolor sit, ametsed itaque</small>
                        <small class="d-block"></small>
                        <small><b>Unit Cost</b> </small>
                        <p class="mb-0">{{formatMoney(6000)}}</p>
                    </div>
                    
                    <div class="holder h-100">
                        <div class="d-flex align-items-end h-100 ">
                            <div class="">
                                <div class=" d-flex aalign-items-center qty">
                                    <span class="badge badge-primary  pointer text-light mr-2" disabled> <i class="fas fa-minus"></i> </span>
                                    <p class="mb-0">2</p>
                                    <span class="badge badge-primary pointer text-light ml-2" disabled> <i class="fas fa-plus"></i> </span>              
                                </div>

                                <div class="ml-auto price mt-2">
                                    <h5 class="mb-0">{{formatMoney(12000)}}</h5>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>

            </b-col>
        </b-row> -->
  </div>
</template>
<script>
import { formatMoney } from "@/utils/helpers";
import { TransactionService } from "@/services";
export default {
  data() {
    return {
      loadingData: false,
      loadError: false,
      image: "https://agbeloba-media.s3.amazonaws.com/maize.jpg",
      orderedProduct: [],
    };
  },
  mounted() {
    this.orderedItems();
  },
  methods: {
    formatMoney,
    async orderedItems() {
      try {
        this.loadingData = true;
        this.loadError = false;
        const data = await TransactionService.getOrderedProducts();
        this.orderedProduct = data;
      } catch (err) {
        this.loadError = true;
        // this.submittingPaystack = false;
      } finally {
        this.loadingData = false;
      }
    },
  },
};
</script>

<style scoped>
.holder {
  position: relative;
  height: 54px;
}

.price {
  right: 0;
}

.order-img {
  width: 100px;
  height: 200px;
}

.order-img img {
  width: inherit !important;
  height: inherit !important;
}

.order-container {
  border-radius: 10px;
  background: #83a95c;
}

.order-container img {
  width: 400px !important;
}

.order-header {
  color: rgb(25, 26, 25);
}
.delivered,
.received,
.confirmed {
  background: green;
  color: #fff;
}
.enroute {
  background: #fff;
  color: #000;
}
.cancelled {
  background: red;
  color: #fff;
}
.pending {
  background: orange;
  color: #000;
}
.mobile-view {
  display: none;
}

@media (max-width: 768px) {
  .mobile-view {
    display: block;
  }
  .desktop-view {
    display: none;
  }
}
</style>
